/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AddLanguageModal from './AddLanguageModal.vue';
import PdfUrlByLanguage from './PdfUrlByLanguage.vue';

/** @typedef {{langCode:string,langLabel:string,url:string}} UrlByLang */

const __vue_script__ = {
    name: 'PlatformPdfs',

    components: { AddLanguageModal, PdfUrlByLanguage },

    props: {
        orgId: {
            type: String,
            required: true,
        },

        type: {
            type: String,
            required: true,
        },

        urls: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            title: this.$i18n.t(`legal_documents.app.legal_pdf_documents.platform.${this.type}`),
            /** @type {UrlByLang[]} */
            urlsByLang: [],
        };
    },

    watch: {
        urls(urls) {
            this.urlsByLang = [];
            for (const lang of Object.keys(urls)) {
                this.addLanguage(lang);
            }
        }
    },

    methods: {
        /** @param {string} langCode */
        addLanguage(langCode) {
            const langLabel = this.$utils.locales.getLocaleLabels([langCode])[0]?.label || langCode;
            const url = this.urls[langCode] || '';
            this.urlsByLang.push({ langCode, langLabel, url });
        },

        openModal() {
            this.$modal.show(
                AddLanguageModal,
                {
                    excludedLanguageCodes: this.urlsByLang.map(d => d.langCode),
                    parent: this,
                },
                { classes: 'small', height: 'auto' },
            );
        },

        emitChange() {
            const urls = this.urlsByLang.reduce(
                (r, { url, langCode }) => url === '' ? r : { ...r, [langCode]: url },
                {},
            );
            this.$emit('change', { platform: this.type, urls });
        },

        /** @param {UrlByLang} data */
        onChange(data) {
            this.urlsByLang = this.urlsByLang.map(d => d.langCode === data.langCode ? data : d);
            this.emitChange();
        },

        /** @param {string} langCode */
        onDelete(langCode) {
            this.urlsByLang = this.urlsByLang.filter(d => d.langCode !== langCode);
            this.emitChange();
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "platform-pdfs" },
    [
      _c("h4", [_vm._v(_vm._s(_vm.title))]),
      _vm._l(_vm.urlsByLang, function (item) {
        return _c("pdf-url-by-language", {
          attrs: {
            orgId: _vm.orgId,
            langCode: item.langCode,
            langLabel: item.langLabel,
            url: item.url,
          },
          on: { change: _vm.onChange, delete: _vm.onDelete },
        })
      }),
      _c("button", { staticClass: "btn", on: { click: _vm.openModal } }, [
        _vm._v(
          _vm._s(_vm.$t("legal_documents.app.legal_pdf_documents.add_language"))
        ),
      ]),
    ],
    2
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/branded-app/legal/PlatformPdfs.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__